import glamorous from "glamorous";

export const Testimonials = glamorous.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
  [theme.main.mediaQueries.tablet]: {
    alignItems: "stretch"
  },
  [theme.main.mediaQueries.mobile]: {
    flexDirection: "column"
  }
}));

export const Testimonial = glamorous.div(({ theme }) => ({
  background: "#fff",
  borderLeft: `7px solid ${theme.main.colors[`vibrant${Math.round(1 + (Math.random() * 4))}`]}`,
  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.15)",
  padding: "1.05rem",
  width: "45%",
  [theme.main.mediaQueries.mobile]: {
    "&:not(:last-child)": {
      marginBottom: "1rem"
    },
    width: "100%"
  }
}));

export const TestimonialQuote = glamorous.blockquote({
  textIndent: "-1.25rem",
  ":before": {
    content: "\\\"",
    color: "#ccc",
    display: "block",
    fontSize: 50,
    marginBottom: -25,
    lineHeight: 1,
    fontFamily: "Palatino"
  }
});

export const TestimonialAuthor = glamorous.div({
  textAlign: "right",
  "& > small": {
    fontStyle: "italic"
  }
});



// WEBPACK FOOTER //
// ./src/components/Testimonials/index.js